import * as Modification from '@/services/legal-ad-form/components/modification';
import * as Company from '@/services/legal-ad-form/components/modification/company';
import * as Decision from '@/services/legal-ad-form/components/modification/decision';
import * as HeadOffice from '@/services/legal-ad-form/components/modification/head-office';
import * as Mention from '@/services/legal-ad-form/components/modification/mention';
import * as Person from '@/services/legal-ad-form/components/modification/person';
import { trimObject } from '@/shared/utils';

export default {
  //transfert_siege_hors_ressort_nouveau_departement_societe_civile
  id: 'transfert-siege-nouveau-departement-commerciale',
  label: 'Transfert de siège hors ressort - Nouveau département (société commerciale)',
  shortLabel: 'Transfert de siège\nsocial',
  componentsData: {
    company: { legalForm: '' },
    headOffice: {},
    decision: { type: '', actor: '' },
    modification: {},
    ownerList: [],
    chairmanList: [],
    ceoList: [],
    chiefExecutiveList: [],
    assistantChiefExecutiveList: [],
    otherMemberList: [],
    mention: { registry: 'Radiation du RCS [Ancien greffe] et immatriculation au RCS [Nouveau greffe]' }
  },
  component: () => import('@/components/legal-ads/forms/models/modification/transfer-new-state-2.vue'),
  validate(modelData) {
    const {
      ownerList,
      chairmanList,
      ceoList,
      chiefExecutiveList,
      assistantChiefExecutiveList,
      otherMemberList,
    } = modelData;

    const allPersonLists = [
      ownerList,
      chairmanList,
      ceoList,
      chiefExecutiveList,
      assistantChiefExecutiveList,
      otherMemberList,
    ];

    const hasAtLeastOnePerson = allPersonLists.some(list => Array.isArray(list) && list.length > 0);

    let errors = trimObject({
      company: Company.validate(modelData.company),
      headOffice: HeadOffice.validate(modelData.headOffice),
      decision: Decision.validate(modelData.decision),
      modification: Modification.validateTransfer(modelData.modification),
      ownerList: Person.validateMany(ownerList),
      chairmanList: Person.validateMany(chairmanList),
      ceoList: Person.validateMany(ceoList),
      chiefExecutiveList: Person.validateMany(chiefExecutiveList),
      assistantChiefExecutiveList: Person.validateMany(assistantChiefExecutiveList),
      otherMemberList: Person.validateMany(otherMemberList),
      mention: Mention.validate(modelData.mention),
    });

    if (!hasAtLeastOnePerson) {
      if (!errors) errors = {};
      const message = "Vous devez renseigner au moins un dirigeant.";

      alert(message);
      errors.missingDirector = { self: message };
    }

    return errors;
  },
  buildContent(modelData) {
    return [
      Company.buildContent(modelData.company, { withShareCapital: true }),
      HeadOffice.buildContent(modelData.headOffice),
      Modification.buildTransferContent(modelData),
      Modification.buildSocialObjectContent(modelData),
      Person.buildManyContent(modelData.ownerList, 'Gérant'),
      Person.buildManyContent(modelData.chairmanList, 'Président'),
      Person.buildManyContent(modelData.ceoList, 'Président directeur général'),
      Person.buildManyContent(modelData.chiefExecutiveList, 'Directeur général'),
      Person.buildManyContent(modelData.assistantChiefExecutiveList, 'Directeur général délégué'),
      Person.buildManyContent(modelData.otherMemberList, 'Personne ayant le pouvoir d\'engager la société'),
      Mention.buildContent(modelData.mention)
    ].flat().join("\n").replace(/undefined/g, '?');
  }
};
